
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1264 1263"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a","x":"134","y":"290.471","width":"1021","height":"583","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dx":"25","dy":"13"}}),_c('feGaussianBlur',{attrs:{"result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#2b2b2b"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('rect',{attrs:{"data-name":"Rectangle 25","width":"1264","height":"1263","rx":"130","fill":"#535353"}}),_c('g',{attrs:{"data-name":"diesvg","fill":"#2b2b2b","stroke":"#ff5e5e","stroke-width":"55"}},[_c('path',{attrs:{"stroke":"none","d":"M156.37 156.895h951.261v950.211H156.37z"}}),_c('path',{attrs:{"fill":"none","d":"M183.87 184.395h896.261v895.211H183.87z"}})]),_c('g',{attrs:{"filter":"url(#a)"}},[_c('text',{attrs:{"x":"50%","y":"50%","dominant-baseline":"middle","text-anchor":"middle","data-name":"td6","fill":"#fff","font-size":"467","font-family":"Impact"}})])])
          )
        }
      }
    